<div class="container-tab-lists" id="remoteactions">
  <div class="inner-tcontainer-tab">
    <div class="tab-body">
      <div class="tab-content">
        <mat-tab-group mat-stretch-tabs="false" #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)">
          <mat-tab label="Tenant Configuration">
            @if (isTenantRemoteActionAdminUser) {
              <allowedactions #allowedActionsComponent
                [commands]="commandList"
                [isEditableMethod]="isEditable"
              (onReloadTemplate)="onReloadCommandTemplate()"></allowedactions>
            } @else {
              <access-denied-card
                title="Access Restricted: Remote Actions Configuration"
                tabName="Tenant Configuration"
                roleCode="MAX_RULEBOOK_TENANT_REMOTEACTIONS"
                roleDescription="Tenant Remote Action Admin: required for tenant-level RA configuration">
              </access-denied-card>
            }
          </mat-tab>
          <mat-tab label="Controller Type Configuration">
            @if (isControllerRemoteActionAdminUser) {
              <allowedactionscontrollertype #allowedActionsControllerTypeComponent
                [commands]="commandList"
                [isEditableMethod]="isEditable"
              (onReloadTemplate)="onReloadCommandTemplate()"></allowedactionscontrollertype>
            } @else {
              <access-denied-card
                title="Access Restricted: Remote Actions Configuration"
                tabName="Controller Type Configuration"
                roleCode="MAX_RULEBOOK_CONTROLLER_REMOTEACTIONS"
                roleDescription="Controller Remote Action Admin: required for global controller-level RA configuration">
              </access-denied-card>
            }
          </mat-tab>
          <mat-tab label="Provisioning Configuration">
            @if (isTenantRemoteActionAdminUser) {
              <provisioningtemplate #provisioningTemplateComponent
                [commands]="commandList"
              [isEditableMethod]="isEditable"></provisioningtemplate>
            } @else {
              <access-denied-card
                title="Access Restricted: Provisioning Configuration"
                tabName="Provisioning Configuration"
                roleCode="MAX_RULEBOOK_TENANT_REMOTEACTIONS"
                roleDescription="Tenant Remote Action Admin: required for tenant-level RA configuration">
              </access-denied-card>
            }
          </mat-tab>

          @if (showTabsByAllowedActionCT('RemoteAdjustParameter')) {
            <mat-tab label="Parameters Configuration">
              @if (isControllerRemoteActionAdminUser) {
                <parametersconfig></parametersconfig>
              } @else {
                <access-denied-card
                  title="Access Restricted: Remote Actions Configuration"
                  tabName="Parameters Configuration"
                  roleCode="MAX_RULEBOOK_CONTROLLER_REMOTEACTIONS"
                  roleDescription="Controller Remote Action Admin: required for global controller-level RA configuration">
                </access-denied-card>
              }
            </mat-tab>
          }

          @if (showTabsByAllowedActionCT('CallFunction')) {
            <mat-tab label="Functions Configuration">
              @if (isControllerRemoteActionAdminUser) {
                <functionsconfig></functionsconfig>
              } @else {
                <access-denied-card
                  title="Access Restricted: Remote Actions Configuration"
                  tabName="Functions Configuration"
                  roleCode="MAX_RULEBOOK_CONTROLLER_REMOTEACTIONS"
                  roleDescription="Controller Remote Action Admin: required for global controller-level RA configuration">
                </access-denied-card>
              }
            </mat-tab>
          }
          @if (showTabsByAllowedActionCT('RemoteReset')) {
            <mat-tab label="Remote Reset Configuration">
              @if (isControllerRemoteActionAdminUser) {
                <remoteresetcommand></remoteresetcommand>
              } @else {
                <access-denied-card
                  title="Access Restricted: Remote Actions Configuration"
                  tabName="Remote Reset Configuration"
                  roleCode="MAX_RULEBOOK_CONTROLLER_REMOTEACTIONS"
                  roleDescription="Controller Remote Action Admin: required for global controller-level RA configuration">
                </access-denied-card>
              }
            </mat-tab>
          }
          @if (showTabsByAllowedActionCT('RemoteReset')) {
            <mat-tab label="Auto Remote Reset Configuration">
              @if (isControllerRemoteActionAdminUser) {
                <autoremoteresetcommand-list></autoremoteresetcommand-list>
              } @else {
                <access-denied-card
                  title="Access Restricted: Remote Actions Configuration"
                  tabName="Auto Remote Reset Configuration"
                  roleCode="MAX_RULEBOOK_CONTROLLER_REMOTEACTIONS"
                  roleDescription="Controller Remote Action Admin: required for global controller-level RA configuration">
                </access-denied-card>
              }
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>